/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const GetUserServices = {
  id: 'user-services.get',
  tag: 'Cluster',
  summary: 'Get all services a user has access to, grouped by organization and project',
  description: 'Get all services a user has access to, grouped by organization and project',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/user/service`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            organizations: z.array(
              z.strictObject({
                id: ZodTypes.Id,
                customerId: ZodTypes.Id,
                name: ZodTypes.KubernetesIdentifier,
                projects: z.array(
                  z.strictObject({
                    id: ZodTypes.Id,
                    name: ZodTypes.KubernetesIdentifier,
                    services: z.array(
                      z.strictObject({
                        id: ZodTypes.Id,
                        name: ZodTypes.KubernetesIdentifier,
                        type: ZodTypes.ServiceType,
                      }),
                    ),
                  }),
                ),
              }),
            ),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
